import {ColorsType, StyleType} from '../../../../utils/theming';

/*
 * ---------------
 * Colors:
 * The color, state, and style props will define the background, border, and text colors applied.
 * ----------------
 */
export const createColorMap = (Colors: ColorsType) => ({
  white: {
    fill: {
      enable: {
        backgroundColor: Colors.neutral100,
        textColor: Colors.neutral1000,
      },
      hover: {
        backgroundColor: Colors.neutral200,
        textColor: Colors.neutral1000,
      },
      focus: {
        backgroundColor: Colors.neutral100,
        textColor: Colors.neutral1000,
        bordersColor: Colors.neutral300,
      },
      disable: {
        backgroundColor: Colors.neutral400,
        textColor: Colors.neutral500,
      },
    },
    outline: {
      enable: {
        textColor: Colors.neutral100,
      },
      hover: {
        backgorundColor: 'rgba(255, 255, 255, 0.20)',
        textColor: Colors.neutral100,
      },
      focus: {
        backgorundColor: 'rgba(255, 255, 255, 0.20)',
        textColor: Colors.neutral100,
      },
      disable: {
        textColor: Colors.neutral500,
      },
    },
    text: {
      enable: {
        iconColor: Colors.neutral100,
        textColor: Colors.neutral100,
      },
      hover: {
        textColor: Colors.neutral100,
        backgroundColor: Colors.neutral300,
      },
      focus: {
        textColor: Colors.neutral100,
        backgroundColor: Colors.neutral300,
      },
      disable: {
        textColor: Colors.neutral500,
      },
    },
  },
  purple: {
    fill: {
      enable: {
        backgroundColor: Colors.primary700,
        textColor: Colors.neutral100,
      },
      hover: {
        backgroundColor: Colors.primary900,
        textColor: Colors.neutral100,
      },
      focus: {
        backgroundColor: Colors.primary700,
        textColor: Colors.neutral100,
        bordersColor: Colors.primary300,
      },
      disable: {
        backgroundColor: Colors.neutral400,
        textColor: Colors.neutral500,
      },
    },
    outline: {
      enable: {
        iconColor: Colors.primary700,
        textColor: Colors.neutral1000,
        bordersColor: Colors.primary700,
      },
      hover: {
        textColor: Colors.primary700,
      },
      focus: {
        textColor: Colors.primary700,
      },
      disable: {
        textColor: Colors.neutral500,
      },
    },
    text: {
      enable: {
        iconColor: Colors.primary700,
        textColor: Colors.neutral1000,
      },
      hover: {
        textColor: Colors.primary700,
        backgroundColor: Colors.neutral200,
      },
      focus: {
        textColor: Colors.primary700,
        backgroundColor: Colors.neutral200,
      },
      disable: {
        textColor: Colors.neutral500,
      },
    },
  },
  red: {
    fill: {
      enable: {
        backgroundColor: Colors.alert300,
        textColor: Colors.neutral100,
      },
      hover: {
        backgroundColor: Colors.alert400,
        textColor: Colors.neutral100,
      },
      focus: {
        backgroundColor: Colors.alert300,
        textColor: Colors.neutral100,
      },
      disable: {
        backgroundColor: Colors.neutral400,
        textColor: Colors.neutral500,
      },
    },
    outline: {
      enable: {
        iconColor: Colors.alert300,
        textColor: Colors.neutral1000,
        bordersColor: Colors.alert300,
      },
      hover: {textColor: Colors.alert300},
      focus: {textColor: Colors.alert300},
      disable: {textColor: Colors.neutral500},
    },
    text: {
      enable: {
        iconColor: Colors.alert300,
        textColor: Colors.neutral1000,
      },
      hover: {textColor: Colors.alert300, backgroundColor: Colors.neutral200},
      focus: {textColor: Colors.alert300, backgroundColor: Colors.neutral200},
      disable: {textColor: Colors.neutral500},
    },
  },
  green: {
    fill: {
      enable: {
        backgroundColor: Colors.success300,
        textColor: Colors.neutral100,
      },
      hover: {
        backgroundColor: Colors.success400,
        textColor: Colors.neutral100,
      },
      focus: {
        backgroundColor: Colors.success300,
        textColor: Colors.neutral100,
        bordersColor: Colors.success300,
      },
      disable: {
        backgroundColor: Colors.neutral400,
        textColor: Colors.neutral500,
      },
    },
    outline: {
      enable: {iconColor: Colors.success300, textColor: Colors.neutral1000},
      hover: {textColor: Colors.success400},
      focus: {textColor: Colors.success400},
      disable: {textColor: Colors.neutral500},
    },
    text: {
      enable: {iconColor: Colors.success300, textColor: Colors.neutral1000},
      hover: {textColor: Colors.success400, backgroundColor: Colors.neutral200},
      focus: {textColor: Colors.success400, backgroundColor: Colors.neutral200},
      disable: {textColor: Colors.neutral500},
    },
  },
  yellow: {
    fill: {
      enable: {
        backgroundColor: Colors.warning300,
        textColor: Colors.neutral1000,
      },
      hover: {
        backgroundColor: Colors.warning400,
        textColor: Colors.neutral1000,
      },
      focus: {
        backgroundColor: Colors.warning300,
        textColor: Colors.neutral1000,
        bordersColor: Colors.warning300,
      },
      disable: {
        backgroundColor: Colors.neutral400,
        textColor: Colors.neutral500,
      },
    },
    outline: {
      enable: {
        iconColor: Colors.warning300,
        textColor: Colors.neutral1000,
        bordersColor: Colors.warning300,
      },
      hover: {textColor: Colors.warning400},
      focus: {textColor: Colors.warning400},
      disable: {textColor: Colors.neutral500},
    },
    text: {
      enable: {iconColor: Colors.warning300, textColor: Colors.neutral1000},
      hover: {textColor: Colors.warning400, backgroundColor: Colors.neutral200},
      focus: {textColor: Colors.warning400, backgroundColor: Colors.neutral200},
      disable: {textColor: Colors.neutral500},
    },
  },
  blue: {
    fill: {
      enable: {
        backgroundColor: Colors.info300,
        textColor: Colors.neutral100,
      },
      hover: {
        backgroundColor: Colors.info400,
        textColor: Colors.neutral100,
      },
      focus: {
        backgroundColor: Colors.info300,
        textColor: Colors.neutral100,
        bordersColor: Colors.info300,
      },
      disable: {
        backgroundColor: Colors.neutral400,
        textColor: Colors.neutral500,
      },
    },
    outline: {
      enable: {
        iconColor: Colors.info300,
        textColor: Colors.neutral1000,
        bordersColor: Colors.info300,
      },
      hover: {textColor: Colors.info300},
      focus: {textColor: Colors.info300},
      disable: {textColor: Colors.neutral500},
    },
    text: {
      enable: {iconColor: Colors.info300, textColor: Colors.neutral1000},
      hover: {textColor: Colors.info300, backgroundColor: Colors.neutral200},
      focus: {textColor: Colors.info300, backgroundColor: Colors.neutral200},
      disable: {textColor: Colors.neutral500},
    },
  },
  teal: {
    fill: {
      enable: {
        backgroundColor: Colors.secondary600,
        textColor: Colors.neutral100,
      },
      hover: {
        backgroundColor: Colors.secondary800,
        textColor: Colors.neutral100,
      },
      focus: {
        backgroundColor: Colors.secondary600,
        textColor: Colors.neutral100,
        bordersColor: Colors.secondary300,
      },
      disable: {
        backgroundColor: Colors.neutral400,
        textColor: Colors.neutral500,
      },
    },
    outline: {
      enable: {
        iconColor: Colors.secondary600,
        textColor: Colors.neutral1000,
        bordersColor: Colors.secondary600,
      },
      hover: {textColor: Colors.secondary600},
      focus: {textColor: Colors.secondary600},
      disable: {
        bordersColor: Colors.neutral600,
        textColor: Colors.neutral500,
      },
    },
    text: {
      enable: {
        iconColor: Colors.secondary600,
        textColor: Colors.neutral1000,
      },
      hover: {
        textColor: Colors.secondary600,
        backgroundColor: Colors.neutral200,
      },
      focus: {
        textColor: Colors.secondary600,
        backgroundColor: Colors.neutral200,
      },
      disable: {
        bordersColor: Colors.neutral600,
        textColor: Colors.neutral500,
      },
    },
  },
  grey: {
    fill: {
      enable: {
        backgroundColor: Colors.neutral500,
        textColor: Colors.neutral100,
      },
      hover: {
        backgroundColor: Colors.neutral700,
        textColor: Colors.neutral100,
      },
      focus: {
        backgroundColor: Colors.neutral500,
        textColor: Colors.neutral100,
        bordersColor: Colors.neutral300,
      },
      disable: {
        backgroundColor: Colors.neutral400,
        textColor: Colors.neutral500,
      },
    },
    outline: {
      enable: {
        iconColor: Colors.neutral500,
        textColor: Colors.neutral1000,
        bordersColor: Colors.neutral500,
      },
      hover: {
        textColor: Colors.neutral500,
      },
      focus: {
        textColor: Colors.neutral500,
      },
      disable: {
        textColor: Colors.neutral500,
      },
    },
    text: {
      enable: {
        iconColor: Colors.neutral500,
        textColor: Colors.neutral1000,
      },
      hover: {
        textColor: Colors.neutral500,
        backgroundColor: Colors.neutral200,
      },
      focus: {
        textColor: Colors.neutral500,
        backgroundColor: Colors.neutral200,
      },
      disable: {
        textColor: Colors.neutral500,
      },
    },
  },
  black: {
    fill: {
      enable: {
        backgroundColor: Colors.neutral1000,
        textColor: Colors.neutral100,
      },
      hover: {
        backgroundColor: Colors.neutral800,
        textColor: Colors.neutral100,
      },
      focus: {
        backgroundColor: Colors.neutral1000,
        textColor: Colors.neutral100,
        bordersColor: Colors.neutral700,
      },
      disable: {
        backgroundColor: Colors.neutral400,
        textColor: Colors.neutral500,
      },
    },
    outline: {
      enable: {
        textColor: Colors.neutral1000,
      },
      hover: {
        backgroundColor: 'rgba(0, 0, 0, 0.20)',
        textColor: Colors.neutral1000,
      },
      focus: {
        backgroundColor: 'rgba(0, 0, 0, 0.20)',
        textColor: Colors.neutral1000,
      },
      disable: {
        textColor: Colors.neutral500,
      },
    },
    text: {
      enable: {
        iconColor: Colors.neutral1000,
        textColor: Colors.neutral1000,
      },
      hover: {
        textColor: Colors.neutral1000,
        backgroundColor: Colors.neutral200,
      },
      focus: {
        textColor: Colors.neutral1000,
        backgroundColor: Colors.neutral200,
      },
      disable: {
        textColor: Colors.neutral500,
      },
    },
  },
});

/* Button container styles */

const boxShadowsByColorMap = (Colors: ColorsType) => ({
  purple: Colors.buttonsPurpleShadow,
  teal: Colors.buttonsTealShadow,
  red: Colors.buttonsRedShadow,
  yellow: Colors.buttonsYellowShadow,
  blue: Colors.buttonsBlueShadow,
  green: Colors.buttonsGreenShadow,
  black: Colors.buttonsBlackShadow,
  white: Colors.buttonsWhiteShadow,
  grey: Colors.buttonsGreyShadow,
});

export const getButtonGeneralStyles = (
  colors: ColorsType,
  color: string,
  style: string,
  state: string,
  textSize: string,
  hasIcon?: boolean,
) => {
  const dynamicColorMap = createColorMap(colors);

  // @ts-ignore
  const {backgroundColor, textColor, bordersColor} =
    // @ts-ignore
    dynamicColorMap[color]?.[style === 'elevated' ? 'fill' : style]?.[state] ||
    {};

  const boxShadowColor = boxShadowsByColorMap(colors);
  const boxShadow =
    style === 'elevated'
      ? // @ts-ignore
        `0px 2px 8px 0px ${boxShadowColor[color]}`
      : undefined;
  const borderColor =
    style === 'outline' ? bordersColor || textColor : bordersColor;
  const borderWidth = style === 'outline' ? 1 : bordersColor ? 1 : 0;

  const cursor = state !== 'disable' ? 'pointer' : 'auto';

  return {
    backgroundColor: backgroundColor || 'transparent',
    borderColor,
    borderWidth,
    textColor,
    cursor,
    ...getButtonPaddings(textSize, style),
    minHeight: getButtonMinHeight(textSize, hasIcon),
    boxShadow: boxShadow,
  };
};

/* Button text styles */
export const getButtonFontStyles = (
  FontStyles: StyleType,
  textSize: string,
) => {
  switch (textSize) {
    case 'large':
      return FontStyles['buttonLG'];
    case 'medium':
      return FontStyles['buttonMD'];
    case 'small':
      return FontStyles['buttonSM'];
    default:
      return FontStyles['buttonLG'];
  }
};

/* Button paddings */
export const getButtonPaddings = (textSize: string, style: string) => {
  const smallPadding =
    style === 'outline' ? {padding: '7px 15px'} : {padding: '8px 16px'};
  const mediumBigPadding =
    style === 'outline' ? {padding: '11px,  23px'} : {padding: '12px  24px'};
  return textSize === 'small' ? smallPadding : mediumBigPadding;
};

export const getButtonMinHeight = (textSize: string, hasIcon?: boolean) => {
  return hasIcon
    ? textSize === 'small'
      ? 40
      : 48
    : textSize === 'small'
    ? 34
    : 42;
};

export const getButtonContentStyles = (
  fontStyles: StyleType,
  colors: ColorsType,
  color: string,
  style: string,
  state: string,
  textSize: string,
) => {
  const dynamicColorMap = createColorMap(colors);

  const textColor =
    // @ts-ignore
    dynamicColorMap[color]?.[style === 'elevated' ? 'fill' : style]?.[state]
      ?.textColor || '';
  const iconColor =
    // @ts-ignore
    dynamicColorMap[color]?.[style === 'elevated' ? 'fill' : style]?.[state]
      ?.iconColor || textColor;

  const buttonGeneralFontStyle = getButtonFontStyles(fontStyles, textSize);

  const lineHeight =
    textSize === 'large' ? '18px' : buttonGeneralFontStyle?.lineHeight + 'px';
  const buttonFontStyle = {
    ...buttonGeneralFontStyle,
    lineHeight: lineHeight,
    color: textColor,
  };

  return {styles: buttonFontStyle, iconColor};
};
